import React, { createContext, useContext, useEffect, useState, useMemo } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("kk_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("kk_cart", JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((curr) => {
      const idx = curr.findIndex((i) => i.product_id === product.id);
      if (idx >= 0) {
        const copy = [...curr];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + qty };
        return copy;
      }
      return [
        ...curr,
        {
          product_id: product.id,
          name: product.name,
          price: product.price,
          compare_at_price: product.compare_at_price || null,
          image: product.images?.[0] || "",
          quantity: qty,
        },
      ];
    });
  };

  const remove = (product_id) => setItems((c) => c.filter((i) => i.product_id !== product_id));
  const update = (product_id, quantity) =>
    setItems((c) =>
      c
        .map((i) => (i.product_id === product_id ? { ...i, quantity: Math.max(1, quantity) } : i))
        .filter((i) => i.quantity > 0)
    );
  const clear = () => setItems([]);

  const total = useMemo(
    () => items.reduce((s, i) => s + i.price * i.quantity, 0),
    [items]
  );
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  return (
    <CartContext.Provider value={{ items, add, remove, update, clear, total, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
